exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\r\n/* .wrapper {\r\n  box-sizing: border-box;\r\n  padding: 0 5%;\r\n} */\n.vehicle[data-v-3d5ff8d2] {\r\n  margin-bottom: 24px;\n}\n.image[data-v-3d5ff8d2] {\r\n  position: relative;\n}\n.image .like-btn[data-v-3d5ff8d2] {\r\n  position: absolute;\r\n  top: 15px;\r\n  right: 15px;\r\n  border: transparent;\r\n  background: transparent;\r\n  padding: 0;\r\n  margin: 0;\r\n  color: #d00000;\n}\n.image img[data-v-3d5ff8d2] {\r\n  width: 100%;\n}\n.title[data-v-3d5ff8d2] {\r\n  font-size: 22px;\r\n  font-weight: bold;\r\n  padding-bottom: 5px;\n}\n.price[data-v-3d5ff8d2] {\r\n  font-size: 2em;\r\n  font-weight: 700;\r\n  color: #2c61d5;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-3d5ff8d2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/garage/garage-favorites-list.vue
// module id = 577
// module chunks = 0